import React, { useState } from 'react'
import './userdeletemodal.css'
import { CiCircleAlert } from "react-icons/ci";

const UserDeleteModal = ({ show, onClose, onDelete }) => {

    const [toastVisible, setToastVisible] = useState(false);
    
      const handleUserDeleteConfirm = () => {
        if (onDelete) onDelete();
        setToastVisible(true);
    
        // Auto-hide the toast after 3s
        setTimeout(() => {
          setToastVisible(false);
        }, 3000);
    
        // Close the modal
        onClose();
      };

  return (
    <>
          {show && (
            <div className="user-delete-modal-overlay" onClick={onClose}>
              <div className="user-delete-modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="alert-content text-center">
                  <CiCircleAlert className="user-delete-alert-icon" />
                  <h2>Are you sure?</h2>
                  <p>
                    Do you really want to delete this file? This action cannot be undone.
                  </p>
                </div>
                <div className="d-flex justify-content-around align-items-center gap-3 mt-4">
                  <button className="user-cancel-btn" onClick={onClose}>
                    Cancel
                  </button>
                  <button className="user-delete-btn" onClick={handleUserDeleteConfirm}>
                    Delete
                  </button>
                </div>
              </div>
            </div>
          )}
    
          {/* Toast Message */}
          {toastVisible && (
            <div className="user-delete-custom-ant-toast">
              User deleted successfully!
              <span className="user-delete-toast-close" onClick={() => setToastVisible(false)}>
                ×
              </span>
            </div>
          )}
        </>
  )
}

export default UserDeleteModal
